import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { busMonitoringApi } from "../../../api/bus/busMonitoringApi";
import { IBaseResponeModel } from "../../../models/response/base-response";
import { eBusMonitoringActionTypeIds, IBusMonitoringDeleteStart, IBusMonitoringLoadStart, IBusMonitoringSaveStart } from "../../action-types/bus/IBusMonitoringActionTypes";
import { busMonitoringActions } from "../../actions/bus/busMonitoringActions";

export function* busMonitoringSaga(): any {
	yield takeLatest(eBusMonitoringActionTypeIds.LOAD_START, loadBusMonitoringWorker)
	yield takeEvery(eBusMonitoringActionTypeIds.DELETE_START, deleteBusMonitoringWorker)
	yield takeEvery(eBusMonitoringActionTypeIds.SAVE_START, saveBusMonitoringWorker)
}

function* loadBusMonitoringWorker(action: IBusMonitoringLoadStart): any {
	const res: IBaseResponeModel = yield call([busMonitoringApi, busMonitoringApi.SelectByCoSo], action.payload)
	if (res.is_success) {
		yield put(busMonitoringActions.loadBusMonitoringSuccess(res.data || []))
	} else {
		yield put(busMonitoringActions.loadBusMonitoringError(res.message || "Không tải được danh sách bus monitoring"))
	}
}

function* deleteBusMonitoringWorker(action: IBusMonitoringDeleteStart): any {
	const res: IBaseResponeModel = yield call([busMonitoringApi, busMonitoringApi.Delete], action.payload)
	if (res.is_success) {
		yield put(busMonitoringActions.deleteBusMonitoringSuccess())
	} else {
		yield put(busMonitoringActions.deleteBusMonitoringErr(res.message || "Không xoá được bus monitoring"))
	}
}

function* saveBusMonitoringWorker(action: IBusMonitoringSaveStart): any {
	let res: IBaseResponeModel;
	if (action.payload.id > 0) {
		res = yield call([busMonitoringApi, busMonitoringApi.Update], action.payload);
	} else {
		res = yield call([busMonitoringApi, busMonitoringApi.Insert], action.payload);
	}
	if (res.is_success) {
		yield put(busMonitoringActions.saveBusMonitoringSuccess())
	} else {
		yield put(busMonitoringActions.saveBusMonitoringError(res.message || "Không lưu được bus monitoring"))
	}
}
